var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenEnded = function SvgOpenEnded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.04 13.1h-.295l-.143.258-1.293 2.337c-.592 1.072-1.358 1.074-1.952 0l-1.293-2.337-.142-.258H.999a.5.5 0 0 1-.499-.5V1C.5.72.719.5.999.5H20c.274 0 .499.226.499.5v11.6c0 .28-.219.5-.499.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h15v1H3zM3 6h15v1H3zM3 9h15v1H3z"
  })))));
};
export default SvgOpenEnded;